import cn from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage } from 'react-intl';
import IconCross from '../../assets/icons/cross.svg';
import { EventName, trackEvent } from '../../utils/tracking';
import Button from '../button';
import styles from '../modal/modal.module.css';
import PrivacyProtectionLink from './privacy-protection-link';

const CookieBanner: React.FC = () => {
  const [showBanner, setBannerVisibility] = React.useState(false);

  React.useEffect(() => {
    if (navigator && navigator.cookieEnabled) {
      if (document && document.cookie.indexOf('visited') === -1) {
        setBannerVisibility(true);
        trackEvent(EventName.CookieConsentDisplay);
      }
    }
  }, []);

  const setCookie = () => {
    document.cookie =
      'visited=yes; expires=Sat, 31 Dec 2030 23:59:59 UTC; path=/';
  };

  const decline = () => {
    trackEvent(EventName.CookieConsentDismissed);
    setCookie();
    setBannerVisibility(false);
  };

  const accept = () => {
    trackEvent(EventName.CookieConsentAccepted);
    setCookie();
    setBannerVisibility(false);
  };

  const banner = () => {
    return (
      <div data-test="div">
        <div
          data-test="cookiemodal-1"
          className="fixed inset-0 z-modal flex items-center justify-center overflow-auto p-6"
        >
          <div className="w-full max-w-lg overflow-hidden rounded-sm bg-other-white">
            <div className="flex items-center justify-between bg-grey-100 px-4 py-2 md:px-6 md:py-4">
              <img
                data-test="cookiemodal-2"
                src="/images/petsdeli-logo-mobile.svg"
                className="h-8 w-auto"
                alt="Pets Deli"
                role="presentation"
              />

              <button
                data-test="cookiedecline"
                className="-mr-2 p-2 text-text-light-bg-secondary hover:text-grey-400 focus:outline-hidden"
                onClick={decline}
                aria-label="Schließen"
              >
                <IconCross className="h-4 w-4" />
              </button>
            </div>
            <div
              data-test="cookiemodal-3"
              className="px-4 pb-4 pt-2 md:px-6 md:pb-6 md:pt-4"
            >
              <div className="text-lg font-medium text-other-black">
                <span
                  data-test="cookiemodal-4"
                  role="img"
                  aria-label="Cookies Icon"
                >
                  🍪{' '}
                </span>
                <FormattedMessage id="cookie-banner:title" />
              </div>

              <div
                data-test="cookieline2"
                className="pt-3 text-sm text-text-secondary"
              >
                <p>
                  <FormattedMessage id="cookie-banner:subtitle" />
                </p>

                <p data-test="cookiemodal-5" className="pt-1">
                  <FormattedMessage
                    id="cookie-banner:privacy-text"
                    values={{
                      privacyProtectionLink: <PrivacyProtectionLink />,
                    }}
                  />
                </p>

                <Button
                  onClick={accept}
                  data-test="button-confirm"
                  className="mt-3 w-full"
                >
                  <FormattedMessage id="cookie-banner:button" />
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className={cn(styles.backdrop, styles.noBlur)}></div>
      </div>
    );
  };

  return <>{showBanner && ReactDOM.createPortal(banner(), document.body)}</>;
};

export default CookieBanner;
